import React, { Component } from 'react';

class ThronPlayer extends Component {
  player = null;

  componentDidMount() {
    const options = {
      clientId: 'valentino',
      xcontentId: this.props.id,
      sessId: this.props.pKey,
      autoplay: true,
      minHeightWidthPercent: 0,
    };

    // noinspection JSUnresolvedFunction
    this.player = window.THRONContentExperience('thron-player', options);

    function onBeforeInit(playerInstance) {
      const schema = window.THRONSchemaHelper.getSchema();

      window.THRONSchemaHelper.removeElementsById(schema, 'IMAGE', ['fullscreenButton', 'captionText']);
      window.THRONSchemaHelper.removeElementsById(schema, 'IMAGEGALLERY', ['fullscreenButton', 'captionText']);

      window.THRONSchemaHelper.removeElementsById(schema, 'VIDEO', ['fullscreenButton', 'captionText', 'speedButton', 'downloadableButton']);
      window.THRONSchemaHelper.removeElementsById(schema, 'VIDEOGALLERY', ['fullscreenButton', 'captionText', 'speedButton', 'downloadableButton']);

      window.THRONSchemaHelper.removeElementsById(schema, 'LIVEEVENT', ['fullscreenButton']);

      window.THRONSchemaHelper.removeElementsById(schema, 'AUDIO', ['fullscreenButton', 'captionText']);
      window.THRONSchemaHelper.removeElementsById(schema, 'AUDIOGALLERY', ['fullscreenButton', 'captionText']);

      window.THRONSchemaHelper.removeElementsById(schema, 'URL', ['fullscreenButton', 'captionText']);
      window.THRONSchemaHelper.removeElementsById(schema, 'PAGELET', ['fullscreenButton']);

      window.THRONSchemaHelper.removeElementsById(schema, 'OTHER', ['fullscreenButton', 'captionText']);
      window.THRONSchemaHelper.removeElementsById(schema, 'OTHER_DOCUMENT', ["captionTextAdvanced", "handTool", "fullscreenButton", "scaleSelect", "downloadableButton", "backToThumbnailButton"]);

      playerInstance.params({ bars: schema });
    }

    this.player.on('beforeInit', onBeforeInit);
  }

  componentWillUnmount() {
    this.player.destroy();
  }

  render() {
    return (
      <div id="thron-player" style={{
        width: '100%',
        height: '100%',
        overflowScrolling: 'touch',
        WebkitOverflowScrolling: 'touch', }} />
    );
  }
}

export default ThronPlayer;
